import { InputsForm } from "@/Components/Index";
import { LayoutCheckoutForm } from "@/Layout/Checkout/LayoutCheckoutForm";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";
import type { MCheckout } from "@/Models/MCheckout/MCheckout";
import React, { useState } from "react";

type Props = {
  MDatos: MCheckout[];
  headleOnClickFrom: (value: MBuyCarCheckout) => void;
  isLoading: boolean;
};

export const FormHomeAddress: React.FC<Props> = ({
  MDatos,
  headleOnClickFrom,
  isLoading
}: Props) => {
  const { ipAddress, basketId, quant, totalSalesPrice } = MDatos[0] ?? {};

  //campos obligatorios
  const [DataMandatory, setDataMandatory] = useState<MBuyCarCheckout>({
    postalCode: "27258",
    cColonia: "Ampliación La Rosita",
    address1: "Paseo Del Tecnológico",
    cStreetNumber: "353",
    interNumber: "",
    reference: "",
    city: "Torreón",
    stateCode: "Coahuila",
    firstName: "Ariel Mata",
    phone: "8711435934",
    //no estan en el formulario
    countryCode: "MX", //MX mexico
    companyName: "", //
    fullName: "",
    lastName: "",
    //basketId del back-end
    id: basketId ?? "",
    //Importantes
    ipAddress: ipAddress ?? "",
    priceSale: totalSalesPrice ?? 0,
    Quantity: quant ?? 0,
    email: "",
  });

  //activar boton
  const [Avility, setAvility] = useState<boolean>(false);

  const checkEmptyOrFalseFields = () => {
    // Crear un array para guardar los campos vacíos o en false
    const emptyOrFalseFields = (
      Object.keys(DataMandatory) as (keyof MBuyCarCheckout)[]
    ).filter((key) => {
      const values = DataMandatory[key];
      return values === "";
    });

    return emptyOrFalseFields;
  };

  const handleChangue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    //data mandatory
    setDataMandatory({
      ...DataMandatory,
      [name]: value,
    });
    //const invalidFields = checkEmptyOrFalseFields();
    //const ActivoButton = invalidFields.length > 0 ? false : true;
    //setAvility(ActivoButton);
  };

  const handdleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") e.preventDefault();
  };

  const handleSubmit = () => {
    //const invalidFields = checkEmptyOrFalseFields();
    //if (invalidFields.length === 0) {
    headleOnClickFrom(DataMandatory);
    //}
  };

  /**********************************************/
  const InputsComponetsDataText = (
    names: string,
    placeholders: string,
    values: string
  ) => (
    <input
      type="text"
      className="form-control develop__inputs"
      id={names}
      name={names}
      placeholder={placeholders}
      onChange={handleChangue}
      value={values}
    />
  );

  const InputsComponetsDataNumber = (
    names: string,
    placeholders: string,
    values: string
  ) => (
    <input
      type="text"
      className="form-control develop__inputs"
      id={names}
      name={names}
      placeholder={placeholders}
      onChange={handleChangue}
      value={values}
      onKeyDown={handdleKeyDown}
    />
  );
  return (
    <LayoutCheckoutForm handleSubmit={handleSubmit} isLoading={isLoading}>
      <div className="row">
        <div className="col-sm-6">
          <InputsForm idx={"postalCode"} titlesx={"Código postal"}>
            {InputsComponetsDataNumber(
              "postalCode",
              "* Código postal",
              DataMandatory.postalCode
            )}
          </InputsForm>
        </div>
        <div className="col-sm-6">
          <InputsForm idx={"cColonia"} titlesx={"Colonia"}>
            {InputsComponetsDataText(
              "cColonia",
              "* Colonia",
              DataMandatory.cColonia
            )}
          </InputsForm>
        </div>
      </div>
      <InputsForm idx={"address1"} titlesx={"Calle"}>
        {InputsComponetsDataText("address1", "* Calle", DataMandatory.address1)}
      </InputsForm>
      <div className="row">
        <div className="col-sm-6">
          <InputsForm idx={"cStreetNumber"} titlesx={"Número exterior"}>
            {InputsComponetsDataNumber(
              "cStreetNumber",
              "* Número exterior",
              DataMandatory.cStreetNumber
            )}
          </InputsForm>
        </div>
        <div className="col-sm-6">
          <InputsForm idx={"interNumber"} titlesx={"Número interior"}>
            {InputsComponetsDataNumber(
              "interNumber",
              "Número interior",
              DataMandatory.interNumber
            )}
          </InputsForm>
        </div>
      </div>
      <InputsForm idx={"reference"} titlesx={"Referencia"}>
        {InputsComponetsDataText(
          "reference",
          "Referencia",
          DataMandatory.reference
        )}
      </InputsForm>
      <div className="row">
        <div className="col-sm-6">
          <InputsForm idx={"city"} titlesx={"Municipio"}>
            {InputsComponetsDataText("city", "* Municipio", DataMandatory.city)}
          </InputsForm>
        </div>
        <div className="col-sm-6">
          <InputsForm idx={"stateCode"} titlesx={"Estado"}>
            {InputsComponetsDataText(
              "stateCode",
              "* Estado",
              DataMandatory.stateCode
            )}
          </InputsForm>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <InputsForm idx={"firstName"} titlesx={"Nombre de quien lo recibe"}>
            {InputsComponetsDataText(
              "firstName",
              "* Nombre de quien lo recibe",
              DataMandatory.firstName
            )}
          </InputsForm>
        </div>
        <div className="col-sm-6">
          <InputsForm idx={"phone"} titlesx={"Teléfono celular"}>
            {InputsComponetsDataNumber(
              "phone",
              "* Teléfono celular",
              DataMandatory.phone
            )}
          </InputsForm>
        </div>
      </div>
    </LayoutCheckoutForm>
  );
};
